export const imageContainer = {
    margin: "0",
    fontWeight: "bold",
    backgroundColor: "#163172",
    color: "white",
    width: "70px"
};

export const navTitle = {
    margin: "0",
    paddingLeft: "5px",
    fontWeight: "bold",
    backgroundColor: "#163172",
    color: "white"
};

export const imageSize = {
    width: "56px",
    height: "50px"
};

export const navButtons = {
    backgroundColor: "#163172",
    color: "white",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "right",
    columnGap: "3px",
    paddingRight: "20px",
    width: "40vw"
};

export const subNavStyle = {
    position: "absolute",
    width: "40%",
    zIndex: "4",
    visibility: "visible",
    backgroundColor: "white",
    right: "5px"
};

export const subMenuButton = {
    height: "40px",
    padding: "10px",
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    flex: "1",
    alignItems: "center"
};

export const profileButtons = {
    cursor: "pointer"
};

export const lineSetparator = {
    margin: 0,
    padding: 0
};

export const navbarSignedIn = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: "30px",
    columnGap: "20px"
};

export const basket = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: "10px",
    cursor: "pointer"
};

export const body = {
    position: "fixed",
    zIndex: "2",
    width: "100%"
};
